import { createContext } from 'react';
import { SettingsContextProps } from '../../types';
import { DEFAULT_STATE } from './constants';

export const SettingsContext = createContext<SettingsContextProps>(DEFAULT_STATE);
